import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery } from '../api';
import { Response } from '../genericInterface';
import { ISharesRequest } from './interface';
import { paginatedResponse } from '../paginatedInterface';

export const creditScoreApi = createApi({
    reducerPath: 'creditScoreApi',
    baseQuery: baseQuery,
    tagTypes: ['creditScore'],
    endpoints: (builder) => ({
        createCreditScore: builder.mutation<
            Response<ISharesRequest>,
            {
                issuerRequest: string;
                creditScore: string;
                internalAnalystComment: string;
                annualCashFlowEstimate: string | number;
                debtToIncome: string | number;
                riskCategory: string;
                loanHistory: string;
                creditBureauScore: string | number;
                internalReviewUrl: string;
                monitoringFrequency: string;
                collateralDetails: string;
                verificationStatus: string;
                authorizedBy: any;
            }
        >({
            query: (body) => ({
                url: `/loan/api/v1/credit-score`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['creditScore'],
        }),
    }),
});

export const { useCreateCreditScoreMutation } = creditScoreApi;
